import { render, staticRenderFns } from "./Obligation.vue?vue&type=template&id=a755078e&"
import script from "./Obligation.vue?vue&type=script&lang=js&"
export * from "./Obligation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports